import { SHOW_MESSAGE, CLOSE_MESSAGE, UPDATE_DATE, CHECK_EXTRACTOPT, CHECK_PUBLISHOPT} from './constants'

/**
 * 
 * @typedef {MessageOptions} messageOptions
 * @property {string} type - info | success | error - determines the style of the message box
 * @property {string} title - title of the message box
 * @property {string} message - message body
 * @property {number} timeout - timeout to autoclose the message in milliseconds, defaults to 5000ms
 * @property {array} buttonArray - Array of button text, defaults to 1 OK button
 * @property {function} onClick - function called when a button is clicked, has 1 arg which is the index provided on button Array. If the default OK button is used, the param will be the default 0
 */

/**
 * @param {MessageOptions} messageOptions - object containing properties for message box
 */
export function showMessage(messageOptions){
    let defaults = {
        type: "", 
        title: "", 
        message: "", 
        timeout: 5000, 
        buttonArray: ["OK"],  
        onClick: (btnIndex)=>(btnIndex),
        shown: true,
        autoClose: true,
        isDate:false,
        isJson:false,
        showDeleteMe: false,
        dateVal:"",
        failedExtract:false,
        failedPublish:false,
        isFailedExport:false,
        data:{}
    }

    return {
        type: SHOW_MESSAGE,
        messageBox: {
            ...defaults,
            ...messageOptions
        }
    }
}

export function closeMessage(){
    return {
        type: CLOSE_MESSAGE,
        messageBox: {
            shown: false
        }
    }
}

export function updateDateVal(dateString){
    return {
        type: UPDATE_DATE,
        messageBox: {
            dateVal: dateString
        }
    }
}

export function checkExtractOption(extractVal){
    return {
        type: CHECK_EXTRACTOPT,
        messageBox: {
            failedExtract: extractVal
        }
    }
}

export function checkPublishOption(publishVal){
    return {
        type: CHECK_PUBLISHOPT,
        messageBox: {
            failedPublish: publishVal
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/messageBox.js